import React from "react";
import Table from "@arachnys/styleguide/Table";
import gql from "graphql-tag";
import { Mutation } from "react-apollo";
import { formatWithJsonSchema } from "../../formatters/formatters";
import { formatDatetimeString } from "../../formatters/formatDateTimeString";
import {
    ENTITY_PROCESS_FRAGMENT,
    ENTITY_DETAILS_QUERY,
} from "../../page/EntityDetail/queries";
import {
    GET_SENTRY_EXECUTIONS_QUERY,
    SentryExecutionsTable,
} from "./SentryExecutionTable";

const RUN_SENTRY_POLICY_NOW_MUTATION = gql`
    mutation RunSentryPolicyNow($entityUlid: String!, $policyUlid: String!) {
        runSentryPolicyNow(entityUlid: $entityUlid, policyUlid: $policyUlid) {
            __typename
            ulid
            createdDate
            status
            sentryEntityPolicy {
                id
                lastExecuted
                scheduledDate
            }
            process {
                ...EntityProcess
            }
        }
    }
    ${ENTITY_PROCESS_FRAGMENT}
`;

const renderActionsCell = ({ entity, sentryPolicy }) => {
    const entityUlid = entity.key.ulid;
    const policyUlid = sentryPolicy.ulid;
    return (
        <Mutation mutation={RUN_SENTRY_POLICY_NOW_MUTATION}>
            {(runSentryPolicyNow, { loading, error }) => {
                if (loading) return "Processing";
                if (error) throw error;
                return (
                    <div>
                        <a
                            onClick={() => {
                                runSentryPolicyNow({
                                    variables: { entityUlid, policyUlid },
                                    refetchQueries: [
                                        {
                                            query: GET_SENTRY_EXECUTIONS_QUERY,
                                            variables: {
                                                entityUlid,
                                                policyUlid,
                                            },
                                        },
                                        {
                                            query: ENTITY_DETAILS_QUERY,
                                            variables: {
                                                id: btoa(
                                                    `Entity:${entityUlid}`
                                                ),
                                                ulid: entityUlid,
                                            },
                                        },
                                    ],
                                });
                            }}
                        >
                            Run Now
                        </a>
                    </div>
                );
            }}
        </Mutation>
    );
};

const columns = [
    {
        expander: true,
        width: 100,
    },
    {
        id: "policy",
        Header: "Policy",
        accessor: "sentryPolicy.processName",
        maxWidth: 100,
    },
    {
        id: "description",
        Header: "Description",
        accessor: "sentryPolicy.policyName",
    },
    {
        id: "frequency",
        Header: "Frequency",
        accessor: "sentryPolicy.pollingFrequency",
        maxWidth: 100,
    },
    {
        id: "sources",
        Header: "Sources",
        accessor: "sentryPolicy.searchEngine",
        maxWidth: 100,
    },
    {
        id: "lastrundate",
        Header: "Last Check Date",
        accessor: "lastExecuted",
        Cell: row => formatDatetimeString({ str: row.value }),
        maxWidth: 120,
    },
    {
        id: "nextrundate",
        Header: "Next Run Date",
        accessor: "scheduledDate",
        Cell: row => formatDatetimeString({ str: row.value }),
        maxWidth: 150,
    },
    {
        id: "actions",
        Header: "Actions",
        maxWidth: 150,
        Cell: row => renderActionsCell(row.original),
    },
];

const PoliciesTable = ({ entity, policySchema }) => {
    const data = (entity.entityPolicies || []).map(policy => ({
        ...policy,
        sentryPolicy: formatWithJsonSchema({
            data: policy.sentryPolicy,
            jsonSchema: policySchema,
        }),
    }));

    return (
        <Table
            columns={columns}
            data={data}
            minRows={2}
            collapseOnDataChange={false}
            SubComponent={row => (
                <div>
                    <SentryExecutionsTable
                        entity={entity}
                        policy={row.original.sentryPolicy}
                    />
                </div>
            )}
        />
    );
};
export default PoliciesTable;
